import {Injectable} from '@angular/core';
import {EdiValidSenderReceiver} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class EdiSenderReceiversAdminService extends TableOptionsService<EdiValidSenderReceiver> {
    constructor() {
        super();
    }

    public override matches(element: EdiValidSenderReceiver, term: string) {
        const lower = term.toLowerCase();
        return [element.isaSenderId, element.senderName, element.isaReceiverId, element.customerName]
            .some(value => value?.toLowerCase().includes(lower));
    }
}
